import { productImageResolution } from '../constants';
/**
 * This function return src for a wrapProductImage.
 *
 * @param src - The image src.
 * @param closestWidth - The image closestWidth width.
 * @param useDevPrefixedUrl - The image use Dev prefixed url.
 * @returns - Return the image url.
 */
const wrapProductImageSrc = (src, closestWidth, useDevPrefixedUrl) => {
    let mappedSrc = decodeURIComponent(src);
    const envString = useDevPrefixedUrl ? 'dev' : 'prod';
    if (!mappedSrc.includes('source[')) {
        mappedSrc = `https://lp2.hm.com/hmgoep${envString}?set=source[${mappedSrc}],origin[dam],category[],type[],res[m],hmver[1]&call=url[file:/product/main]`;
    }
    if (useDevPrefixedUrl && mappedSrc.indexOf('hmgoepprod') !== -1) {
        mappedSrc = mappedSrc.replace(/hmgoepprod/, 'hmgoepdev');
    }
    if (mappedSrc.indexOf('portfolio') !== -1) {
        mappedSrc = mappedSrc.replace('ImageVersion', 'target[hm.com],ImageVersion');
    }
    if (!mappedSrc.includes('res[')) {
        mappedSrc = mappedSrc.replace('&hmver', `,res[m]&hmver`).replace(',hmver', `,res[m],hmver`);
    }
    return mappedSrc
        .replace(/res\[.\]/, productImageResolution[closestWidth][0])
        .replace(/call=url\[[^\]]*\]/, productImageResolution[closestWidth][1]);
};
export default wrapProductImageSrc;
//# sourceMappingURL=wrapProductImageSrc.js.map